(function() {
  function init() {
    var section = document.querySelector('[id$="__featured_product_list_bayDXV"]');
    if (!section) return;

    var items = section.querySelectorAll('squama-item');
    var btn = section.querySelector('.noxor-featured-cta');

    // État initial — tout caché
    items.forEach(function(item) {
      item.style.opacity = '0';
      item.style.transform = 'translateY(24px)';
      item.style.transition = 'opacity 0.6s cubic-bezier(0.4,0,0.2,1), transform 0.6s cubic-bezier(0.4,0,0.2,1)';
    });

    if (btn) {
      btn.style.opacity = '0';
      btn.style.transform = 'translateY(16px)';
      btn.style.transition = 'opacity 0.6s cubic-bezier(0.4,0,0.2,1) 0.6s, transform 0.6s cubic-bezier(0.4,0,0.2,1) 0.6s';
    }

    // Observer sur les cards
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var index = Array.from(items).indexOf(entry.target);
        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }, index * 150);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    items.forEach(function(item) { observer.observe(item); });

    // Observer séparé sur le bouton
    if (btn) {
      var btnObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          btn.style.opacity = '1';
          btn.style.transform = 'translateY(0)';
          btnObserver.unobserve(entry.target);
        });
      }, { threshold: 0.1 });

      btnObserver.observe(btn);
    }
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
